var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titleBarDiv"},[_c('div',{staticClass:"commonLineDiv"}),_c('div',{staticClass:"commonTitleDiv ws_oneLine",style:({color:_vm.isWarn?'red':'#3796F3'})},[_vm._v(" "+_vm._s(_vm.title || "")+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }